export default "__VITE_ASSET__CvLbu$Lh__"